import React, { useState } from "react";
import ReceiptLayout from "./ReceiptLayout";
import ReceiptForm from "./ReceiptForm";
import shortid from "shortid";
import useLocalState from "../../hooks/useLocalState";

export default function ReceiptMaker() {
  const [name, setName] = useLocalState("name", "Starbucks");
  const [address, setAddress] = useLocalState(
    "address",
    "10 Russell St, Covent Garden"
  );
  const [city, setCity] = useLocalState("city", "London WC2B 5HZ");
  const [fontFamily, setFontFamily] = useLocalState(
    "font-family",
    "sans-serif"
  );
  const [priceSymbol, setPriceSymbol] = useLocalState("currency", "USD");
  const [tankYouNote, setTankYouNote] = useLocalState(
    "thank-you",
    "Thank you for purchasing with us."
  );
  const [taxFields, setTaxFields] = useLocalState("tax", [
    {
      id: shortid.generate(),
      taxType: "VAT",
      taxPercent: "5",
    },
  ]);
  const [itemFields, setItemFields] = useState([
    {
      id: shortid.generate(),
      description: "Chai Tea Latte - Garden",
      qty: 1,
      price: 0,
    },
  ]);
  const [businessLogo, setBusinessLogo] = useLocalState(
    "logo",
    "https://receiptmaker.netlify.app/social-media-cover-image.jpg"
  );
  const [checked, setChecked] = useLocalState("checked", false);

  return (
    <section>
      <div className="container mx-auto p-2 my-8">
        <div className="flex flex-wrap">
          <div id="form-test" className="w-full md:w-1/2 p-6 bg-white shadow">
            <h2 className="text-3xl font-bold ">Customize your receipt</h2>
            <div
              role="radiogroup"
              aria-labelledby="group_label"
              className="select-none mt-4"
            >
              <label>
                <input
                  type="radio"
                  name="business-log"
                  checked={!checked}
                  onChange={() => setChecked(!checked)}
                />
                <span className="ml-2">Text logo</span>
              </label>
              <label className="ml-4">
                <input
                  type="radio"
                  name="business-log"
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                />
                <span className="ml-2">Image logo</span>
              </label>
            </div>
            <ReceiptForm
              name={name}
              address={address}
              city={city}
              setCity={setCity}
              setAddress={setAddress}
              setName={setName}
              priceSymbol={priceSymbol}
              setPriceSymbol={setPriceSymbol}
              taxFields={taxFields}
              setTaxFields={setTaxFields}
              itemFields={itemFields}
              setItemFields={setItemFields}
              fontFamily={fontFamily}
              setFontFamily={setFontFamily}
              tankYouNote={tankYouNote}
              setTankYouNote={setTankYouNote}
              checked={checked}
              setBusinessLogo={setBusinessLogo}
            />
          </div>
          <div className="w-full md:w-1/2 pt-4 md:pt-0">
            <ReceiptLayout
              name={name}
              address={address}
              city={city}
              priceSymbol={priceSymbol}
              taxFields={taxFields}
              itemFields={itemFields}
              fontFamily={fontFamily}
              tankYouNote={tankYouNote}
              checked={checked}
              businessLogo={businessLogo}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
